import joinRight from './right'

export default joinRight
